import { httpClient } from '@/services/http/httpClient'

type UpdateWorkflowTaskParams = {
  ideaId: string
  taskId: string
  endDate?: Date | null
  completed?: boolean
}

export async function updateWorkflowTask({
  ideaId,
  taskId,
  endDate,
  completed,
}: UpdateWorkflowTaskParams): Promise<void> {
  await httpClient.put(`/ideas/funnel/steps/${taskId}/update`, {
    ideaId,
    endDate,
    completed,
  })
}
